import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { operationsApi } from '@/features/workspace/api';

interface ArticleItem {
  id: string;
  title: string;
  journal: string | null;
  stage: string;
  status: string;
  payment_state: string;
  partner_label: string | null;
}

export const OperationsArticlesView: React.FC = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState<ArticleItem[]>([]);
  const [stats, setStats] = useState({
    total_cards: 5,
    stages_count: 5,
    in_process: 3,
    coeditors: 2,
  });
  const [loading, setLoading] = useState<boolean>(true);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const res = await operationsApi.module('articles');
      const data = res as {
        articles: ArticleItem[];
        stats: {
          total_cards: number;
          stages_count: number;
          in_process: number;
          coeditors: number;
        };
      };
      setArticles(data.articles || []);
      if (data.stats) setStats(data.stats);
    } catch {
      setArticles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <button
            type="button"
            onClick={() => navigate('/app/operations')}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              backgroundColor: '#1e293b',
              border: '1px solid #334155',
              color: '#94a3b8',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            ←
          </button>
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#f8fafc', margin: 0 }}>
              Совместные статьи
            </h1>
            <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.875rem' }}>
              Контроль этапов совместных научных статей и публикаций
            </p>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
        <div style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '10px', padding: '1.25rem' }}>
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase' }}>Всего статей</div>
          <div style={{ fontSize: '1.875rem', fontWeight: 700, color: '#38bdf8', marginTop: '4px' }}>{stats.total_cards}</div>
        </div>
        <div style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '10px', padding: '1.25rem' }}>
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase' }}>Этапов</div>
          <div style={{ fontSize: '1.875rem', fontWeight: 700, color: '#fbbf24', marginTop: '4px' }}>{stats.stages_count}</div>
        </div>
        <div style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '10px', padding: '1.25rem' }}>
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase' }}>В процессе</div>
          <div style={{ fontSize: '1.875rem', fontWeight: 700, color: '#10b981', marginTop: '4px' }}>{stats.in_process}</div>
        </div>
        <div style={{ backgroundColor: '#0f172a', border: '1px solid #1e293b', borderRadius: '10px', padding: '1.25rem' }}>
          <div style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase' }}>Соавторы</div>
          <div style={{ fontSize: '1.875rem', fontWeight: 700, color: '#a855f7', marginTop: '4px' }}>{stats.coeditors}</div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: '#0f172a',
          border: '1px solid #1e293b',
          borderRadius: '10px',
          overflowX: 'auto',
        }}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '850px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #1e293b', backgroundColor: '#0b1120' }}>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Статья
              </th>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Журнал
              </th>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Этап
              </th>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Статус
              </th>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Оплата
              </th>
              <th style={{ padding: '0.875rem 1rem', color: '#64748b', fontSize: '0.75rem', textTransform: 'uppercase' }}>
                Партнёр
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ padding: '3rem', textAlign: 'center', color: '#94a3b8' }}>
                  Загрузка статей...
                </td>
              </tr>
            ) : articles.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>
                  Статьи не найдены
                </td>
              </tr>
            ) : (
              articles.map((art) => (
                <tr
                  key={art.id}
                  style={{
                    borderBottom: '1px solid #1e293b',
                  }}
                >
                  <td style={{ padding: '1rem', color: '#f8fafc', fontWeight: 600, fontSize: '0.875rem' }}>
                    {art.title}
                  </td>
                  <td style={{ padding: '1rem', color: '#38bdf8', fontSize: '0.8125rem' }}>
                    {art.journal || '—'}
                  </td>
                  <td style={{ padding: '1rem', color: '#cbd5e1', fontSize: '0.8125rem' }}>
                    {art.stage}
                  </td>
                  <td style={{ padding: '1rem', color: '#10b981', fontSize: '0.8125rem', fontWeight: 500 }}>
                    {art.status}
                  </td>
                  <td style={{ padding: '1rem', color: '#94a3b8', fontSize: '0.8125rem' }}>
                    {art.payment_state}
                  </td>
                  <td style={{ padding: '1rem', color: '#cbd5e1', fontSize: '0.8125rem' }}>
                    {art.partner_label || '—'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
